<template>
  <div>
    <router-view />
  </div>
</template>
<script>
export default {
  name: "casino-lobby-config",
  data: () => ({
    //
  })
}
</script>